import React from "react";
import { useParams } from "react-router-dom";
import DOMPurify from "dompurify";
import { AllVendorLeadsdetail, AllVendorsUploads } from "../../FetchAPI";
import DeshbordBreadcrumb from "../Breadcrumb/DeshbordBreadcrumb";
import Sidebar from "../Sidebar";
import CustomersUploads from "../AllCatServiceWiseLead/CustomersUploads";
import LawyerUploads from "../AllCatServiceWiseLead/LawyerUploads";
import LeadStatusStepper from "../LeadStatusStepers/LeadStatusStepper";
import LeadChatbot from "../AllCatServiceWiseLead/LeadChatbot";
import DeshBoardFooter from "../DeshBoardFooter";
import { Helmet } from "react-helmet";
import { useAuth } from "../../../Store/AuthContext";

// import VendorUploads from "../../AllCatServiceWiseLead/VendorUploads";

export default function AllLeadtotalDetails() {
  let { leadid } = useParams();
  const { RendomTokenfetch, userRoll } = useAuth();

  const [LeadDetails, setLeadDetails] = React.useState([]);

  const Fetchleaddetails = React.useCallback(async () => {
    try {
      const data = await AllVendorLeadsdetail(RendomTokenfetch, leadid);
      setLeadDetails(data);
    } catch (error) {
      console.error("Error fetching leads:", error);
    } finally {
    }
  }, [RendomTokenfetch, leadid]);

  const [refresh, setRefresh] = React.useState(false);

  const triggerRefresh = () => setRefresh((prev) => !prev);

  React.useEffect(() => {
    Fetchleaddetails();
  }, [refresh, Fetchleaddetails]);

  const [uploadData] = AllVendorsUploads(RendomTokenfetch, leadid, userRoll);
  // const [VedorData] = AllCustumertUploads(RendomTokenfetch, leadid, userRoll);

  const servicID = LeadDetails.service_id;
  const detailsStatusID = LeadDetails.status_id;

  var BGIMGStyle = {
    backgroundImage: "url(../images/deviderlien.png)",
    height: "100%",
    width: "100%",
    backgroundPosition: "center",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    position: "absolute",
    bottom: "-40px",
    // bottom: "-20px",
  };

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow"></meta>
      </Helmet>
      <div className="page-wrapper dashboard mm-page mm-slideout" id="mm-0">
        <Sidebar />
        <DeshbordBreadcrumb
          page1={[
            { name: "My Leads", pagelink: "all-leads" },
            { name: LeadDetails.name },
          ]}
        />
        <section className="user-dashboard transaction-history">
          <div className="dashboard-outer dashboardouter">
            <div className="row">
              <div className="col-xl-7 col-lg-7 col-md-6 col-sm-12 mb-4">
                <div className="card height-equal card_wallet">
                  <div className="leaddetailsdatbox">
                    <div className="descsbox">
                      <div
                        className="bgimagedividerbox"
                        style={BGIMGStyle}
                      ></div>
                      <div className="leadsrImgBox">
                        <span className="thumb mx-0">
                          {LeadDetails.service_icon !== "" ? (
                            <img src={LeadDetails.service_icon} alt="" />
                          ) : (
                            <img src="images/resource/candidate-1.png" alt="" />
                          )}
                        </span>

                        <div className="ms-sm-2 leadnametacskBox">
                          <h3 className="name">
                            <span>{LeadDetails.name}</span>
                          </h3>
                          <ul className="job-info justify-content-start at-clv7 mt-1 leaddetailsUlli">
                            <li className="ms-0 ps-0">
                              <span>Category:</span> {LeadDetails.category}
                            </li>
                            <li className="ms-0 ps-0">
                              <span>Task Id:</span> #{LeadDetails.id}
                            </li>
                          </ul>
                        </div>
                      </div>
                      {/* <div className="CommnetsLeadbox">
                      <VendorLeadCommentBtn
                        RendomTokenfetch={RendomTokenfetch}
                        leadID={leadid}
                      />
                    </div> */}
                      <div className="leadStatusbox">
                        <span
                          className="badge"
                          style={{ color: "white", backgroundColor: "green" }}
                        >
                          {LeadDetails.status}
                        </span>
                      </div>
                    </div>
                    <div className="detailsBody mt-4">
                      <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-12">
                          <p className="oldname">
                            <span>Old Name: </span>
                            {LeadDetails.oldname}
                          </p>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12">
                          <p className="newname">
                            <span>New Name: </span> {LeadDetails.newname}
                          </p>
                        </div>
                        <div className="col-lg-12 col-md-12 col-sm-12 mb-3">
                          <p className="bodydescription">
                            <span>Description:</span>
                          </p>
                          <div className="descriptionBody">
                            <p
                              dangerouslySetInnerHTML={{
                                __html: DOMPurify.sanitize(
                                  LeadDetails.description
                                ),
                              }}
                            ></p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <CustomersUploads
                    RendomTokenfetch={RendomTokenfetch}
                    leadID={LeadDetails.id}
                  />

                  {/* <VendorUploads uploadData={VedorData} /> */}

                  <LawyerUploads
                    uploadData={uploadData}
                    name={"Uploaded Documents By YourdoorStep"}
                  />

                  <div className="LeadStatusStepper">
                    <div className="SectionBoxintro">
                      <h4 className="p-0">Process</h4>
                    </div>
                    <div className="card-body custom-input">
                      <LeadStatusStepper
                        RendomTokenfetch={RendomTokenfetch}
                        leadID={leadid}
                        servicID={servicID}
                        detailsStatusID={detailsStatusID}
                        triggerRefresh={triggerRefresh}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-5 col-lg-5 col-md-6  mb-12">
                {/* <div className="card height-equal card_wallet">
                  <div className="SectionBoxintro">
                    <h4>Need more help?</h4>
                  </div>
                  <div className="card-body custom-input pt-0">
                    <div className="leadsrImgBox needMoreBox">
                      <span className="thumb mx-0">
                        <img src="../images/resource/candidate-1.png" alt="" />
                      </span>
                      <div className="textbos ms-0 ms-sm-2">
                        <p className="mb-0 textbos">Contact expert</p>
                        <h3 className="name">
                          <a href="/">yourdoorstep</a>
                        </h3>
                      </div>
                    </div>
                    <div className="callWhatsappBTN">
                      <Link
                        to={`tel:${webSetting.mobile_number}`}
                        className="CallBoxBtn"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <i className="fa fa-phone" aria-hidden="true"></i> Call
                      </Link>
                      <Link
                        to={`https://wa.me/${webSetting.whatsapp}?text=Hi, I would like to speak to a Name Change Service`}
                        target="_blank"
                        rel="noreferrer"
                        className="whatsappBoxBtn"
                      >
                        <i className="fa fa-whatsapp" aria-hidden="true"></i>{" "}
                        Whatsapp
                      </Link>
                    </div>
                  </div>
                </div> */}
                <LeadChatbot
                  RendomTokenfetch={RendomTokenfetch}
                  leadID={leadid}
                />
              </div>
            </div>
          </div>
        </section>
        <div className="deshboard_footer">
          <DeshBoardFooter />
        </div>
      </div>
    </>
  );
}
